/* eslint-disable */
import React, { useContext, useEffect } from 'react';
import { Grid, Hidden } from '@mui/material';
import { Redirect, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@cpg-its/ads.common.button';
import Banner from '@cpg-its/ads.containers.banner';
import Loader from '@cpg-its/ads.common.loading-circle';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../constants/routes';
import { TcsmStates } from '../../../../root/tcsm-model';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { SearchProps } from '../../models/arc-epi-props';
import { useBillingAccountState } from './useBillingAccountsState';
import { setCurrentBillingAccount } from './billing-accounts-slice';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { SearchApp } from '../../../../search/components/search-app';
import { SearchList } from '../../../../search/components/search-list';
import { ListPagination } from '../../../../search/components/list-pagination';
import { BillingAccountsListLabels } from './billing-account-list-labels';
import { BillingAccountView } from './billing-account-view';
import { BillingAccount } from './billing-accounts-models';
import { unloadParticipantsState } from '../participants/participants-slices';
import { setInstitutionClientNumber } from '../institutions/institution-slice';
import { sortTableStyles } from '../../../../global/constants/theme/styles/tables/generic-sort-table';
import { MainContent } from '../../../../global/components/layout/main-content-container';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { paddingStyles } from '../../../../global/constants/theme/styles/layout/paddingStyles';
import { GroupsState } from '../groups/groups-model';
import { ExternalLinks } from '../../../../global/models/lov-proc-model';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { SearchBar } from '../../../../search/components/search-bar';
import { FilterGroup } from '../../../../search/components/filter-group';
import { usePersonManagementReset } from '../../hooks/usePersonManagementReset';
import { DemographicsContext } from '../../../../global/models/demographics-model';
import { AuthenticatedState } from '../../../../global/models/authenticated-model';
import { EmploymentState } from '../employment/employment-model';
import { setNavigationContext } from '../../../../global/ducks/app-context';
import { NavigationContext } from '../../../../global/models/app-context-model';
import { ExternalLink } from '../../../../global/components/external-link-modal';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';

export function BillingAccountsSearch() {
  const token = useSelector<TcsmStates, string>(state => state.authenticatedState?.accessToken);
  const labelSettings = useSelector<TcsmStates, LabelSettingProps>(state => state.epiProps.labelSettingState.epiContent);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps.searchSettingsState.epiContent);
	const groupsState = useSelector<TcsmStates, GroupsState>(state => state.groupsState);
	const externalLinks = useSelector<TcsmStates, ExternalLinks>(state => state.lovProcState?.externalLinks);
	const groupSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.GroupSearch}`);
	const participantSearch = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.BillingAccountsSearch}${ArcRoutes.Participants}`);
	const dispatch = useDispatch();
	const history = useHistory();
	const billingAccountState = useBillingAccountState(groupsState?.currentGroup?.group_id);
	const initialList = billingAccountState.billingAccounts;
	const tableClasses = sortTableStyles();
	const paddingClasses = paddingStyles();
	const location = useLocation();
	const app = useContext(DemographicsContext);
	const authenticatedState = useSelector<TcsmStates, AuthenticatedState>(state => state.authenticatedState);
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
	const employeeSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.EmployeeSearch}`);
	const userNavigationContext = useSelector<TcsmStates, NavigationContext>(state => state.appContext.userNavigationContext);
	const { state } = useLocation<any>();
	const routeMatch = useRouteMatch();
	const gpsItem = useGpsType(GpsType.BILLING_ACCOUNT);

	usePersonManagementReset(false, true);

	useEffect(() => {
		dispatch(unloadParticipantsState());
	}, []);

	useEffect(() => {
		if (userNavigationContext === NavigationContext.BillingAccount) {
			dispatch(setNavigationContext(NavigationContext.GroupAdmin));
		}
	}, [userNavigationContext]);

	const selectedGroupId = groupsState?.currentGroup?.group_id;

	if (!selectedGroupId) {
		return (
			<Redirect to={{
				pathname: groupSelect,
				state: {
					externalAction: state?.externalAction,
					actionLink: routeMatch.path,
					finalAction: state?.finalAction,
				},
			}} />);
	}

	if (!billingAccountState.billingAccountsLoaded) {
		return (<Loader />);
	}

	const onSetBillingAccount = (accountNumber: string) => {
		const match = initialList.filter(x => x.account_number === accountNumber)[0];
		if (match) {
			match.group_id = selectedGroupId;
			dispatch(setCurrentBillingAccount(match));
			dispatch(setInstitutionClientNumber(match.account_owner_client_number));
			dispatch(setNavigationContext(NavigationContext.BillingAccount));
		}

		if (state?.externalAction)
			window.open(state?.externalAction?.replace('{account}', accountNumber, '_blank'));
		else
			history.push(state?.finalAction || participantSearch, state);
	};

	return (
		<>
			<Grid className={paddingClasses.containerBottomPadding} container>
				<MainContent>
					{!!billingAccountState?.billingAccounts?.length && <ContentSpacer>
						<Banner
							banner={{
								type: 'info',
								label: <WysiwygWithReactLink content={searchSettings?.billPayMessage} />,
							}}
						/>
					</ContentSpacer>}
					<PageHeader
						headerText={searchSettings?.billingAccountSearchTitle}
						description={searchSettings?.billingAccountSearchDescription}
					/>
				</MainContent>

				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
				</SideBarContent>

			</Grid>

      {!!billingAccountState?.billingAccounts?.length && (
        <Grid container alignItems='center' justifyContent='flex-end' style={{ height: 68 }}>
          <Grid item style={{ height: 44.5, position: 'relative', top: initialList?.length < 10 ? 0 : '4.25rem', display: 'flex' }}>
            <ExternalLink className="btn-primary" linkUrl={labelSettings?.paymentusUrl} linkText={labelSettings?.paymentusButtonText} />
          </Grid>
        </Grid>
      )}

			<SearchApp initialList={initialList} appName={`${selectedGroupId}-BillingAccountSearch`}>
				<FilterGroup hide={initialList?.length < 10}>
					<Grid container alignItems='center' justifyContent='space-between'>
						<Grid item xs={9} md={7} lg={6}>
							<SearchBar label={searchSettings.billingAccountSearchBarLabel || 'Search'} name='billing-account-search-bar' filterProps={['account_number', 'account_name', 'billing_city']} />
						</Grid>
						{!!billingAccountState?.billingAccounts?.length && <Grid container item xs={3} md={3} lg={3} justifyContent='flex-end'>
							<Button type='button' buttonStyle='primary' text='Pay My Bill' onClick={() => window.open('https://www.cpg.org', '_blank')} />
						</Grid>}
					</Grid>
				</FilterGroup>

				<div className={tableClasses.sortTable}>
					<Hidden xsDown>
						<BillingAccountsListLabels settings={searchSettings} />
					</Hidden>
					<div className='sort-table-content'>
						<SearchList
							renderList={
								(item) => {
									return <BillingAccountView
										settings={searchSettings}
										key={item.account_number} item={item}
										onSetBillingAccount={() => { onSetBillingAccount((item as BillingAccount)?.account_number); }}
										billingAccountUrl={externalLinks?.billing_history_page}
                    bearerToken={token}
										externalLinkState={
											{
												history,
												location,
												dispatch,
												app,
												authenticatedState,
												employmentState,
												employeeSelect,
											}
										} />;
								}
							}
							renderPagination={
								(totalCounts, name) => {
									return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings.nextButton} prevButton={searchSettings.previousButton} />;
								}
							}
							emptyMessage={searchSettings.emptyListMessage}
						/>
					</div>
				</div>

			</SearchApp>
		</>
	);
}
